import React from 'react';

export const Badge = (props) => {
    return (
        <small style={{ height: "1.1rem", background: props.bgColor }} className={"badge badge-" + props.servirity}>{props.icon && <i className={props.icon} />} {props.data}</small>
    );
}